import { Modal } from "./modal";
import { setupModalTriggers } from "../../helpers/events";

customElements.define("uwp-modal", Modal);
setupModalTriggers();
